import { BrandingConfiguration, BrandingSettingsRef } from 'pbts/c1/api/settings/v1/branding'
import { BrandingSettingsServiceClient } from 'pbts/c1/api/settings/v1/branding.client'
import { createMutationApi } from './lib/createMutationApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const updateBrandingSettingsApi = createMutationApi(
    BrandingSettingsServiceClient,
    'update',
    (r) => r?.branding as BrandingConfiguration,
    BrandingSettingsRef.typeName,
)

export const setBrandingLogoApi = createMutationApi(
    BrandingSettingsServiceClient,
    'setBrandingLogo',
    (r) => r?.branding as BrandingConfiguration,
    BrandingSettingsRef.typeName,
)

export const setBrandingLogoWhiteApi = createMutationApi(
    BrandingSettingsServiceClient,
    'setBrandingLogoWhite',
    (r) => r?.branding as BrandingConfiguration,
    BrandingSettingsRef.typeName,
)

export const setBrandingFaviconApi = createMutationApi(
    BrandingSettingsServiceClient,
    'setBrandingFavicon',
    (r) => r?.branding as BrandingConfiguration,
    BrandingSettingsRef.typeName,
)

export const setBrandingFaviconWhiteApi = createMutationApi(
    BrandingSettingsServiceClient,
    'setBrandingFaviconWhite',
    (r) => r?.branding as BrandingConfiguration,
    BrandingSettingsRef.typeName,
)

export const introspectBrandingApi = createUnaryApi(
    BrandingSettingsServiceClient,
    'introspect',
    (r) => r?.branding as BrandingConfiguration,
    BrandingSettingsRef.typeName,
)
